'use client';
import { ComponentType } from 'react';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import { Props } from './overhead.component';
import dynamic from 'next/dynamic';

const DynamicOverheadComponent: ComponentType<Props> = dynamic(
  () => import('./overhead.component')
);

export default DynamicOverheadComponent;

export function calculateOverheadPlaceholderConfig(): PlaceholderConfig {
  const heightSinceWidth = [{ sinceWidth: 0, height: 30 }];

  return {
    heightSinceWidth
  };
}
